import { Box, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { LOAD_LEVELS, LOAD_ORDER } from '../utils/constants';
import Panel from './Panel';
import PanelTitle from './PanelTitle';
import LoadTag from './LoadTag';

/** What each load level means. */
export default function LoadLegend({ capacityPerDay }) {
  return (
    <Panel sx={{ p: 2.5 }}>
      <PanelTitle title="How load is measured" hint={`Hours against ${capacityPerDay}h per person per working day`} />
      <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, mt: 1.5, display: 'grid', gap: 1 }}>
        {LOAD_ORDER.map((key) => (
          <Box component="li" key={key} display="flex" alignItems="center" justifyContent="space-between" gap={1}>
            <LoadTag level={key} small />
            <Typography sx={{ fontSize: 12, color: WD.inkMuted }}>{LOAD_LEVELS[key].rule}</Typography>
          </Box>
        ))}
      </Box>
    </Panel>
  );
}
